<template>
  <div class="caseView">
    <div class="title">
      <img src="./img/titleMd.png" alt="">
    </div>
    <p class="bigTitle">案例分析</p>
    <MdCaseList :case-title="item"  v-for="item in caseTitleList" :key="item.ID"/>
    <!-- 内容 -->
    <!-- <div class="caseBox" >
      <div class="boxTop">
        <p>
          {{item.Name}}
        </p>
      </div>
      <div class="boxBottom">
        <div class="boxBottomItem" v-for="item in 5" :key="item" @click="goCaseShow">
          <div class="itemImg">
            <img  src="./img/caseboxItem.png" alt="">
          </div>
          <p class="itemTitle">德尔康终端+电商全设备sasasaa</p>
          <p class="itemInfo">通过实施物流信息系统，德尔康医药建立了对仓储物流中心运作的精细化作业管理，作业效率和数据准确性得到很…</p> 
        </div>
      </div>
    </div> -->
    <!-- 没有数据 -->

  </div>
</template>

<script>
import MdCaseList from './components/caseList/MdCaseList.vue';
// 引入获取解决方案类型
import { customerCaseType } from '@/api/client'
export default {
  data() {
    return {
      caseTitleList:[]
    }
  },
  components:{MdCaseList},
  mounted () {
    this.customerCaseType()
  },
  methods: {
        // 获取客户案例类型
    async customerCaseType () {
      const res = await customerCaseType()
      // console.log(res, 'customerCaseTypecustomerCaseType')
      if (res.Msg === '获取成功') {
        this.caseTitleList = res.Data
        // this.$store.commit('getCaseTitle', res.Data)
      }
    },

  }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
p{
  margin: 0;
}
.caseView{
  width: 100%;
  .title{
    width: 750px/$md;
    height: 300px/$md;
    margin-bottom: 40px/$md;
    img{
      width: 100%;
    }
  }
}
.bigTitle{
  font-size: 32px/$md;
  font-weight: 400;
  color: #000000;
  text-align: center;
  margin-bottom: 20px/$md;
}
.caseBox{
    width: 690px/$md;
    margin: auto;
    .boxTop{
      height: 50px/$md;
      border-bottom: 3px/$md solid #eee;
      margin-bottom: 40px/$md;
      p{
        width: 140px/$md;
        height: 50px/$md;
        border-bottom: 3px/$md solid #2380E1;
        color: #2380E1;
        text-align: center;
        font-weight: bold;
        letter-spacing: 2px/$md;
      }
    }
    .boxBottom{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .boxBottomItem{
      width: 318px/$md;
      height:315px/$md;
      margin-bottom: 40px/$md;
      .itemImg{
        width: 266px/$md;
        height:137px/$md;
        margin: auto;
        margin-bottom: 24px/$md;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .itemTitle{
        width: 297px/$md;
        margin: auto;
        font-size: 24px/$md;
        margin-bottom: 29px/$md;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space:nowrap; //溢出不换行
      }
      .itemInfo{
        height:93px/$md;
        font-size: 18px/$md;
        font-weight: 400;
        line-height: 32px/$md;
        color: #666666;
        letter-spacing: 1px/$md;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }
}
</style>
